import { useTheme } from "@mui/material";

export const useDashboardColors = () => {
  const theme = useTheme();
  const colorNames = ["primary", "secondary", "info", "success", "warning", "error", "violet"];

  const getColorPalette = (colorOrIndex: string | number) => {
    let colorName: string;

    if (typeof colorOrIndex === "number") {
      colorName = colorNames[colorOrIndex % colorNames.length];
    } else {
      colorName = colorOrIndex;
    }

    if (colorName === "violet") {
      return { 
        main: "#7C3AED",   // Violet icon color
        light: "#F3E8FF"   // Light violet background
      };
    }

    const palette = (theme.palette as any)[colorName] || theme.palette.primary;
    
    return {
      main: palette.main,
      light: palette.light,
    };
  };

  return { getColorPalette, colorNames };
};
